import { CoopUser, CoopUserWithOnline, ProjectUser } from '@aipb/personal-content/shared/model';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { TranslocoModule } from '@jsverse/transloco';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'pc-message-user-list',
  imports: [CommonModule, MatChipsModule, MatIconModule, TranslocoModule],
  templateUrl: './message-user-list.component.html',
  styleUrls: ['./message-user-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageUserListComponent {
  @Input() users: (CoopUser | CoopUserWithOnline | ProjectUser)[] = [];
  // @ts-expect-error foo
  @Input() currentUserId: string;

  @Output() sendMessageToUser = new EventEmitter<string>();

  hasOnline(user: CoopUser | CoopUserWithOnline | ProjectUser) {
    return 'online' in user;
  }
}
